import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import Card from "../../../../components/Card";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import DisposisiPrimer from "../../../../utilities/primer/DisposisiPrimer";
import { formatDateTimeLocalDate } from "../../../../utilities/Utils";
import { FaBook, FaEdit, FaEye, FaFile, FaFilePdf, FaPaperPlane, FaTasks } from "react-icons/fa";
import ModalST from "../modal/ModalST";
import ModalTindakLanjutST from "../modal/ModalTindakLanjutST";
import ModalAudit from "../modal/ModalAudit";
import ModalInspeksi from "../modal/ModalInspeksi";
import ModalChecklist from "../modal/ModalChecklist";
import ModalHasilChecklist from "../modal/ModalHasilChecklist";
import ModalReviu from "../modal/ModalReviu";
import ModalRekom from "../modal/ModalRekom";
import ModalApproval from "../modal/ModalApproval";
import ModalPreviewPdf from "../modal/ModalPreviewPdf";

const ExpandableComponentPrimer = ({ data, reloadList, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const resPenugasan = await pbumkuService.listUmkuPenugasanAll(data.nomorAju)
                setListDisposisi(resPenugasan.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [pbumkuService, data])

    return (
        <Card>
            <Card.Body>
                {loading && <Spinner />}
                <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                    <ul className="list-inline p-0 m-0 w-100">
                        {
                            listDisposisi.map((disp, index) => {
                                return (
                                    <li key={index}>
                                        <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                        <h6 className="float-left mb-1"><DisposisiPrimer idDisposisi={disp.idDisposisi} /></h6>
                                        <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.tglTugas)}</small>
                                        {
                                            disp.idDisposisi === 9 && disp.noTugas !== null &&
                                            <>
                                                <div className="d-inline-block w-100">
                                                    <small>Nomor Sertifikat : <strong><GetNomorSertifikat nomorAju={data.nomorAju}/></strong></small>
                                                </div>
                                            </>
                                        }
                                        <div className="d-inline-block w-100">
                                            <DisposisiProses dataPrimer={data} dataPenugasan={disp} reloadList={reloadList} jenisIzin={jenisIzin} />
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </Card.Body>
        </Card>
    )
}

const DisposisiProses = ({ dataPrimer, dataPenugasan, reloadList, jenisIzin }) => {

    const [dataDisposisi, setDataDisposisi] = useState(null)
    const [isEdit, setIsEdit] = useState(false)

    const [showEvp, setShowEvp] = useState(false)
    const handleCloseEvp = () => {
        setShowEvp(false)
    }
    const [showBatalInspeksi, setShowBatalInspeksi] = useState(false)
    const handleCloseBatalInspeksi = () => {
        setShowBatalInspeksi(false)
    }
    const [showAudit, setShowAudit] = useState(false)
    const handleCloseAudit = () => {
        setShowAudit(false)
    }
    const [showInspeksi, setShowInspeksi] = useState(false)
    const handleCloseInspeksi = () => {
        setShowInspeksi(false)
    }
    const [showReviuRekom, setShowReviuRekom] = useState(false)
    const handleCloseReviuRekom = () => {
        setShowReviuRekom(false)
    }
    const [showApproval, setShowApproval] = useState(false)
    const handleCloseApproval = () => {
        setShowApproval(false)
    }
    //tindak lanjut Permohonan
    const [showTLSP, setShowTLSP] = useState(false)
    const handleCloseTLSP = () => {
        setShowTLSP(false)
    }

    const handleShow = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        if (dataPenugasan.idDisposisi === 1) {
            setShowEvp(true)
        } else if (dataPenugasan.idDisposisi === 4) {
            setShowProsesST(true)
        } else if (dataPenugasan.idDisposisi === 5) {
            setShowAudit(true)
        } else if (dataPenugasan.idDisposisi === 6) {
            setShowBatalInspeksi(true)
        } else if (dataPenugasan.idDisposisi === 7) {
            setShowInspeksi(true)
            setIsEdit(true)
        } else if (dataPenugasan.idDisposisi === 8) {
            setIsEdit(true)
            setShowReviuRekom(true)
        } else if (dataPenugasan.idDisposisi === 9) {
            setIsEdit(true)
            setShowApproval(true)
        } else if (dataPenugasan.idDisposisi === 2) {
            setShowTLSP(true)
        }
    }

    const [showTlSt, setShowTlSt] = useState(false)
    const handleCloseTlST = () => {
        setShowTlSt(false)
    }
    const handleTindakLanjutST = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowTlSt(true)
    }

    const [showProsesST, setShowProsesST] = useState(false)
    const handleCloseProsesST = () => {
        setShowProsesST(false)
    }
    const handleProsesST = (isEdit) => {
        setIsEdit(isEdit)
        setShowProsesST(true)
    }

    const [showChecklist, setShowChecklist] = useState(false)
    const handleCloseChecklist = () => {
        setShowChecklist(false)
    }
    const handleViewChecklist = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowChecklist(true)
    }

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => {
        setShowHasilInspeksi(false)
    }
    const handleViewHasilInspeksi = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowHasilInspeksi(true)
    }

    const [showRekom, setShowRekom] = useState(false)
    const handleCloseRekom = () => setShowRekom(false)
    const handleViewRekom = (dataPenugasan, isEdit) => {
        setDataDisposisi(dataPenugasan)
        setIsEdit(isEdit)
        setShowRekom(true)
    }

    const [showPreview, setShowPreview] = useState(false)
    const handleClosePreview = () => setShowPreview(false)
    const handleClickPreview = (dataPenugasan) => {
        // console.log(dataPrimer)
        setDataDisposisi(dataPenugasan)
        setShowPreview(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-8">
                    {
                        ((localStorage.getItem("role") !== '4' && localStorage.getItem("role") !== '5' && localStorage.getItem("role") !== '8') && dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShow(dataPenugasan, true)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShow(dataPenugasan, false)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>
                            {' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 4 && dataPenugasan.noTugas !== null && dataPrimer.kodeStatus === '024' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Tindak Lanjut ST</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleTindakLanjutST(dataPenugasan, true)}>
                                    <FaEdit /> Tindak Lanjut ST
                                </Button>
                            </OverlayTrigger>{' '}

                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 7 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Checklist</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewChecklist(dataPenugasan, true)}>
                                    <FaFile /> Data Checklist
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Hasil Inspeksi</Tooltip>
                            }>
                                <Button size="sm" variant="primary" onClick={() => handleViewHasilInspeksi(dataPenugasan, true)}>
                                    <FaBook /> Hasil Inspeksi
                                </Button>
                            </OverlayTrigger>
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 8 && dataPenugasan.noTugas !== null &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Rekomendasi</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleViewRekom(dataPenugasan, true)}>
                                    <FaTasks /> Rekomendasi
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 3 && dataPenugasan.noTugas !== null && dataPrimer.kodeStatus === '022' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses ST</Tooltip>
                            }>
                                <Button size="sm" variant="primary" onClick={() => handleProsesST(true)}>
                                    <FaPaperPlane /> Proses Surat Tugas
                                </Button>
                            </OverlayTrigger>{' '}

                        </>
                    }
                    {
                        dataPenugasan.idDisposisi === 9 && dataPenugasan.noTugas !== null && dataPrimer.kodeStatus === '100' &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Preview PDF</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning" onClick={() => handleClickPreview(dataPenugasan)}>
                                    <FaFilePdf /> Preview PDF
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalST showProsesST={showProsesST} handleCloseProsesST={handleCloseProsesST} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} />
            <ModalTindakLanjutST showTlSt={showTlSt} handleCloseTlSt={handleCloseTlST} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} />
            <ModalAudit showAudit={showAudit} handleCloseAudit={handleCloseAudit} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalInspeksi showInspeksi={showInspeksi} handleCloseInspeksi={handleCloseInspeksi} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalChecklist showChecklist={showChecklist} handleCloseChecklist={handleCloseChecklist} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalHasilChecklist showHasilChecklist={showHasilInspeksi} handleCloseHasilChecklist={handleCloseHasilInspeksi} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalReviu showReviu={showReviuRekom} handleCloseReviu={handleCloseReviuRekom} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalRekom showRekom={showRekom} handleCloseRekom={handleCloseRekom} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalApproval showApproval={showApproval} handleCloseApproval={handleCloseApproval} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} reloadList={reloadList} isEdit={isEdit} jenisIzin={jenisIzin} />
            <ModalPreviewPdf showPreview={showPreview} handleClosePreview={handleClosePreview} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} jenisIzin={jenisIzin}/>
        </>
    )
}

const GetNomorSertifikat = ({ nomorAju }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [nomorSertifikat, setNomorSertifikat] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!nomorAju) {
            return
        }

        try {
            const resSert = await pbumkuService.getUmkuApprovalByAju(nomorAju)
            // console.log(resSert)
            setNomorSertifikat(resSert?.data?.nomorSertifikat)
        } catch (error) {
            console.log(error)
        }
    }, [nomorAju, pbumkuService])

    useEffect(() => {
        let isMounted = true;
        if (!nomorAju) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [nomorAju, fetchAllData]);

    return (
        <>
            {nomorSertifikat ? nomorSertifikat : '-'}
        </>
    )
}

export default ExpandableComponentPrimer